export default __webpack_public_path__ + "static/media/affiliate-4.1d3e0a7b.png";